// --------------------------------------------------------
// ATESTADO/DECLARACAO - AtestadoDeclaracaoField
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import { Radio, TextField } from '@mui/material';
import React from 'react'
import { Text } from '../../../../../../../components/UI/generalLayout/Layout.styled';
import { MediumInput } from '../DetailsAttendanceRecord.styled';
import InputMask from 'react-input-mask';
import useResponsiveInfo from '../../../../../../../hooks/useResponsiveInfo';
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// ATESTADO/DECLARACAO INTERFACE
// --------------------------------------------------------

interface IAtestadoDeclaracaoField {
    atestadoDeclaracao: any;
    isViewState: boolean;
    setAtestadoDeclaracao: (value: any) => void;
}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const AtestadoDeclaracaoField = ({ atestadoDeclaracao, isViewState, setAtestadoDeclaracao }: IAtestadoDeclaracaoField) => {
    // --------------------------------------------------------
    // ATESTADO/DECLARACAO PRIVATE DECLARATIONS
    // --------------------------------------------------------
    const { isMobile } = useResponsiveInfo();
    // --------------------------------------------------------

    // --------------------------------------------------------
    // REACT RETURN FUNCTION
    // --------------------------------------------------------
    return (
        <>
            <div style={{ flexDirection: isMobile ? 'column' : 'row', display: 'flex', gap: isMobile ? 0 : 20 }}>
                <div style={{ flexDirection: 'row', display: 'flex', gap: 0 }}>
                    <Radio
                        disabled={isViewState}
                        checked={atestadoDeclaracao.tipo === 'atestado'}
                        onChange={() => setAtestadoDeclaracao((prev: any) => { return { ...prev, tipo: 'atestado' } })}
                    />
                    <Text>Atestado médico</Text>
                </div>
                <div style={{ flexDirection: 'row', display: 'flex', gap: 5 }}>
                    <Radio
                        disabled={isViewState}
                        checked={atestadoDeclaracao.tipo === 'declaracao'}
                        onChange={() => setAtestadoDeclaracao((prev: any) => { return { ...prev, tipo: 'declaracao' } })}
                    />
                    <Text>Declaração de comparecimento</Text>
                </div>
            </div>
            <div style={{ flexDirection: 'row', display: 'flex', gap: 20, marginBottom: 20 }}>
                <div>
                    <Text bold style={{ fontSize: 14 }}>Dia:</Text>
                    <InputMask
                        mask="99/99/9999"
                        onKeyPress={e => { e.key === 'Enter' && e.preventDefault() }}
                        maskPlaceholder="" value={atestadoDeclaracao.data}
                        disabled={isViewState}
                        onChange={(event: any) => { setAtestadoDeclaracao((prev: any) => { return { ...prev, data: event.target.value } }) }}
                    >
                        <TextField error={false} style={{ marginRight: 10, width: 130, marginTop: -10 }} />
                    </InputMask>
                </div>
                <div>
                    <Text bold style={{ fontSize: 14 }}>Horário de início:</Text>
                    <InputMask
                        mask="99:99"
                        disabled={isViewState}
                        onKeyPress={e => { e.key === 'Enter' && e.preventDefault() }}
                        maskPlaceholder="" value={atestadoDeclaracao.horario}
                        onChange={(event: any) => { setAtestadoDeclaracao((prev: any) => { return { ...prev, horario: event.target.value } }) }}
                    >
                        <TextField error={false} style={{ marginRight: 10, width: 80, marginTop: -10 }} />
                    </InputMask>
                </div>
                {atestadoDeclaracao.tipo === 'atestado' && (
                    <div>
                        <Text bold style={{ fontSize: 14 }}>Dias afastados:</Text>
                        <InputMask
                            mask="99"
                            disabled={isViewState}
                            onKeyPress={e => { e.key === 'Enter' && e.preventDefault() }}
                            maskPlaceholder="" value={atestadoDeclaracao.diasAfastados}
                            onChange={(event: any) => { setAtestadoDeclaracao((prev: any) => { return { ...prev, diasAfastados: event.target.value } }) }}
                        >
                            <TextField error={false} style={{ marginRight: 10, width: 80, marginTop: -10 }} />
                        </InputMask>
                    </div>
                )}
                {atestadoDeclaracao.tipo === 'declaracao' && (
                    <div>
                        <Text bold style={{ fontSize: 14 }}>Horário final:</Text>
                        <InputMask
                            mask="99:99"
                            disabled={isViewState}
                            onKeyPress={e => { e.key === 'Enter' && e.preventDefault() }}
                            maskPlaceholder="" value={atestadoDeclaracao.horarioFim}
                            onChange={(event: any) => { setAtestadoDeclaracao((prev: any) => { return { ...prev, horarioFim: event.target.value } }) }}
                        >
                            <TextField error={false} style={{ marginRight: 10, width: 80, marginTop: -10 }} />
                        </InputMask>
                    </div>
                )}
            </div>
            <Text bold style={{ fontSize: 14 }}>Notas do atestado</Text>
            <MediumInput
                disabled={isViewState}
                onChange={(event: any) => {
                    setAtestadoDeclaracao((prev: any) => { return { ...prev, notas: event.target.value } })
                }}
                value={atestadoDeclaracao.notas}
                placeholder="Notas do atestado"
            />
        </>
    )
    // --------------------------------------------------------
}

export default AtestadoDeclaracaoField